// extracted by mini-css-extract-plugin
export default {"suggestWrapperStyled":"classes_suggestWrapperStyled__ArJgV"};